import type { ComponentPropsWithRef } from 'react';
import { forwardRef } from 'react';

type ButtonProps = ComponentPropsWithRef<'button'>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { children, ...buttonProps } = props;

    return (
      <button
        ref={ref}
        type="button"
        onClick={buttonProps.onClick}
        {...buttonProps}
        className={buttonProps.className}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = '@signate-cloud/user-app/Button';
